import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import PropTypes from 'prop-types';

import { certsFormattedMessage, getMessageKey } from '../../../utils/utils';

import {
  BULK_ACTION_FOOTER_BTNS_REVERSE,
  getBulkActionFooterBtns,
} from './constant';

function BulkActionEndDateHeader({ id, bulkFooterStats }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);

  const buttonKey = BULK_ACTION_FOOTER_BTNS_REVERSE?.[id];
  const buttonObjectsForTotal = getBulkActionFooterBtns(
    campaignType,
    reassignConfigMap
  )[buttonKey]?.objectsToTotal;
  const headerCount = buttonObjectsForTotal?.reduce((total, item) => {
    if (bulkFooterStats[item]) {
      return total + bulkFooterStats[item];
    }

    return total;
  }, 0);

  const messageKey =
    headerCount > 1
      ? 'CERT_BULK_CED_COUNT_HEADER_MULTIPLE'
      : 'CERT_BULK_CED_COUNT_HEADER_SINGLE';

  return certsFormattedMessage(
    messages.messageKey || localize(intl, getMessageKey(messageKey)),
    {
      count: headerCount,
    }
  );
}

BulkActionEndDateHeader.propTypes = {
  id: PropTypes.string.isRequired,
  bulkFooterStats: PropTypes.shape({}),
};

BulkActionEndDateHeader.defaultProps = { bulkFooterStats: {} };

export default BulkActionEndDateHeader;
